/* global debounce, localData */
const searchHeaderPosts = (search, searchInput) => {
  if (search.value) {
    axios
      .post(localData.siteURL, {  action: 'searchPostsHeader', keyword: search.value, lang: localData.lang, id: localData.id }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        searchInput.classList.add('is-active');
        // eslint-disable-next-line no-param-reassign
        searchInput.innerHTML = response.data.html;
      });
  } else {
    searchInput.classList.remove('is-active');
  }
}
const removeClass = () => {
  const links = document.querySelectorAll('.header-search__results-item');
  links.forEach((link) => {
    link.classList.remove('hover');
  });
}
const addClass = (key) => {
  const links = document.querySelectorAll('.header-search__results-item');
  links.forEach((link, k) => {
    if ((key-1) === k) {
      link.classList.add('hover');
    }
  });
}
const addHoverClassAndSearch = (e, searchField, searchInput) => {
  if (e.keyCode === 38 || e.keyCode === 40) {
    const end = searchField.value.length;
    searchField.setSelectionRange(end, end);
    searchField.focus();
    let activeItem = 0;
    const links = document.querySelectorAll('.header-search__results-item');
    links.forEach((link, key) => {
      if (link.classList.contains('hover')) {
        activeItem = key+1;
      }
    });
    removeClass();
    if (e.keyCode === 38) {
      addClass(activeItem-1);
    } else if (e.keyCode === 40) {
      addClass(activeItem+1);
    }
  } else if (e.keyCode === 13) {
    const result = document.querySelector('.header-search__results-item.hover')
    if (result) {
      if (result.href) {
        window.location = result.href;
      } else {
        window.location = result.querySelector('a').href
      }
    }
  } else {
    searchHeaderPosts(searchField, searchInput);
  }
}

const searchField = document.querySelector('input#search');
if (searchField) {
  const searchInput = document.querySelector('.header-search__results');
  searchField.addEventListener('keyup', debounce((e) => {
    addHoverClassAndSearch(e, searchField, searchInput);
  }, 300));
}

